import { render } from "./FilmPage.vue?vue&type=template&id=15426900&scoped=true"
import script from "./FilmPage.vue?vue&type=script&lang=js"
export * from "./FilmPage.vue?vue&type=script&lang=js"

import "./FilmPage.vue?vue&type=style&index=0&id=15426900&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15426900"]])

export default __exports__